<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="(item, key) in active_list" :key="key" :label="item.label" :name="item.value" v-show="Acs('/sale-analysis/' + item.value)"></el-tab-pane>
            </el-tabs>

            <DayTraces v-if="activeName == 'day-traces'" :activeName="activeName"></DayTraces>

            <div v-else-if="activeName == 'goal-finish'">
                <el-row class="searchSection">
                    <el-col :span="8" :offset="8">
                        <el-tabs v-model="finishActiveName" @tab-click="handleFinishClick">
                            <el-tab-pane v-for="(item, key) in finish_active_list" :key="key" :label="item.label" :name="item.value"></el-tab-pane>
                        </el-tabs>
                    </el-col>
                </el-row>
                <GoalFinishPfm v-if="finishActiveName == 'goal-finish-pfm'" :activeName="finishActiveName"></GoalFinishPfm>
                <GoalFinishRenew v-if="finishActiveName == 'goal-finish-renew'" :activeName="finishActiveName" @handleView="handleView"></GoalFinishRenew>
                <GoalFinishActual v-if="finishActiveName == 'goal-finish-actual'" :activeName="finishActiveName"></GoalFinishActual>
                <GoalFinishDetail v-if="finishActiveName == 'goal-finish-detail'" :activeName="finishActiveName"></GoalFinishDetail>
            </div>

            <div v-else-if="activeName == 'goal-manage'">
                <el-row class="searchSection">
                    <el-col :span="8" :offset="8">
                        <el-tabs v-model="goalActiveName" @tab-click="handleGoalClick">
                            <el-tab-pane v-for="(item, key) in goal_active_list" :key="key" :label="item.label" :name="item.value"></el-tab-pane>
                        </el-tabs>
                    </el-col>
                </el-row>
                <GoalManagePfm v-if="goalActiveName == 'goal-manage-pfm'" :activeName="goalActiveName" :is_edit="true"></GoalManagePfm>
                <GoalManageRenew v-else-if="goalActiveName == 'goal-manage-renew'" :activeName="goalActiveName"></GoalManageRenew>
                <GoalManageActual v-else-if="goalActiveName == 'goal-manage-actual'" :activeName="goalActiveName"></GoalManageActual>
            </div>

            <ProductAnalysis v-else-if="activeName == 'product-analysis'" :activeName="activeName"></ProductAnalysis>

            <AreaAnalysis v-else-if="activeName == 'area-analysis'" :activeName="activeName"></AreaAnalysis>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
import DayTraces from "~/views/count/table/dayTraces.vue";
import GoalFinishPfm from "~/views/count/table/goalFinishPfm.vue";
import GoalFinishRenew from "~/views/count/table/goalFinishRenew.vue";
import GoalFinishActual from "~/views/count/table/goalFinishActual.vue";
import GoalFinishDetail from "~/views/count/table/goalFinishDetail.vue";
import GoalManagePfm from "~/views/count/table/goalManagePfm.vue";
import GoalManageRenew from "~/views/count/table/goalManageRenew.vue";
import GoalManageActual from "~/views/count/table/goalManageActual.vue";
import ProductAnalysis from "~/views/count/table/productAnalysis.vue";
import AreaAnalysis from "~/views/count/table/areaAnalysis.vue";
export default {
    name: "saleanalysis",

    components: {
        DayTraces,
        GoalFinishPfm,
        GoalFinishRenew,
        GoalFinishActual,
        GoalFinishDetail,
        GoalManagePfm,
        GoalManageRenew,
        GoalManageActual,
        ProductAnalysis,
        AreaAnalysis
    },

    props: {
        
    },

    data() {
        return {
            activeName: '',
            active_list: [
                {
                    label: '日跟进分析',
                    value: 'day-traces',
                },
                {
                    label: '目标完成情况',
                    value: 'goal-finish',
                },
                {
                    label: '业绩目标管理',
                    value: 'goal-manage',
                },
                {
                    label: '产品分析',
                    value: 'product-analysis',
                },
                {
                    label: '区域分析',
                    value: 'area-analysis',
                }
            ],
            finishActiveName: 'goal-finish-pfm',
            finish_active_list: [
                {
                    label: '新增业绩',
                    value: 'goal-finish-pfm',
                },
                {
                    label: '续费业绩',
                    value: 'goal-finish-renew',
                },
                {
                    label: '回款业绩',
                    value: 'goal-finish-actual',
                },
                {
                    label: '续费明细表',
                    value: 'goal-finish-detail',
                }
            ],

            goalActiveName: 'goal-manage-pfm',
            goal_active_list: [
                {
                    label: '新增业绩目标',
                    value: 'goal-manage-pfm',
                },
                {
                    label: '续费业绩目标',
                    value: 'goal-manage-renew',
                },
                {
                    label: '回款业绩目标',
                    value: 'goal-manage-actual',
                }
            ],
        };
    },

    mounted() {

    },

    created() {
        this.activeName = this.$route.query['activeName'] ? this.$route.query['activeName'].toString() : '';
        this.finishActiveName = this.$route.query['finishActiveName'] ? this.$route.query['finishActiveName'].toString() : 'goal-finish-pfm';
        this.active_list = this.active_list.filter(item=>{
            if(!this.Acs('/sale-analysis/' + item.value)){
                return false;
            }else if(!this.activeName){
                this.activeName = item.value;
            }
            return true;
        })
    },

    methods: {
        handleClick(tab, event) {

        },

        handleFinishClick(tab, event){

        },

        handleGoalClick(tab, event){

        },

        // 查看
        handleView(query) {
            let routeData = this.$router.resolve({
                path: query.path,
                query: query,
            });
            window.open(routeData.href, '_blank');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/views/count/saleanalysis.vue